import styled from "styled-components";
import {Link} from "react-router-dom";

// Styled component for the header, conditional rendering based on whether linkTo is provided
const LabelHeader = styled(({linkTo, ...props}) => linkTo ? <Link {...props} to={linkTo}/> : <div {...props} />)`
  width: 315px;
  display: flex;
  overflow: hidden;
  height: 60px;
  cursor: pointer;
  margin-bottom: 10px;
`;

const LabelHeaderMain = styled.div`
  width: 310px;
  height: 60px;
  background: rgb(0, 148, 255);
  display: flex;
  align-items: center;
  padding-left: 20px;
`;

const LabelHeaderMainText = styled.p`
  font-size: 22px;
  font-family: signika, sans-serif;
  color: white;
`;

const RightTriangleContainer = styled.div`
  bottom: 0;
  left: auto;
  overflow: hidden;
  width: 5px;
`;

const RightTriangle = styled.div`
  border: 5px solid transparent;
  border-left-color: rgb(0, 148, 255);
  background-color: rgb(0, 148, 255, 0);

  ${LabelHeader}:hover & {
    display: none;
  }
`;

export default function HomeLabelHeader({title, linkTo}) {
  return (<LabelHeader linkTo={linkTo}>
    <LabelHeaderMain>
      <LabelHeaderMainText>{title}</LabelHeaderMainText>
    </LabelHeaderMain>
    <RightTriangleContainer>
      <RightTriangle style={{marginTop: "-5px"}}/>
      <RightTriangle/>
      <RightTriangle/>
      <RightTriangle/>
      <RightTriangle/>
      <RightTriangle/>
      <RightTriangle/>
    </RightTriangleContainer>
  </LabelHeader>);
}
